import { c as _c } from "react/compiler-runtime";
import type { MouseEvent } from 'react';
import useEntityId from '@/entity/hooks/use-entity-id';
import useEntityKind from '@/entity/hooks/use-entity-kind';
import { useOpenPage } from '@/hooks/use-open-page';
const useOpenTrace = () => {
  const $ = _c(4);
  const entityId = useEntityId();
  const entityKind = useEntityKind();
  const handleOpenPage = useOpenPage();
  let t0;
  if ($[0] !== entityId || $[1] !== entityKind?.urlPath || $[2] !== handleOpenPage) {
    t0 = (event, onboardingId) => handleOpenPage(event, `/${entityKind?.urlPath}/${entityId}/onboardings/${onboardingId}/trace`);
    $[0] = entityId;
    $[1] = entityKind?.urlPath;
    $[2] = handleOpenPage;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};
export default useOpenTrace;